import { useEffect, useState, RefObject } from 'react';

const isSSR = typeof document === 'undefined';

export function useOutsideClick(
  ref: RefObject<HTMLElement> | RefObject<HTMLElement>[],
  isUsed?: boolean,
  callback?: () => void,
  exceptions?: string | string[]
) {
  const [isClosed, setClosed] = useState(false);
  if (isSSR) {
    return [isClosed, setClosed];
  }

  function checkExceptions(e: any) {
    if (!exceptions || typeof e?.target?.className !== 'string') {
      return true;
    }

    if (Array.isArray(exceptions)) {
      return exceptions.every(exc => e.target.className.indexOf(exc) < 0);
    }

    return e.target.className.indexOf(exceptions) < 0;
  }

  function handleClickOutside(event: MouseEvent) {
    let forwardClickOutside;

    if (Array.isArray(ref)) {
      forwardClickOutside =
        ref.every(ref => ref.current && !ref.current.contains(event.target as Node)) &&
        checkExceptions(event);
    } else {
      forwardClickOutside =
        ref.current && !ref.current.contains(event.target as Element) && checkExceptions(event);
    }

    if (forwardClickOutside) {
      setClosed(true);
      callback?.();
    }
  }

  useEffect(() => {
    if (isUsed) {
      window.addEventListener('click', handleClickOutside);
    }
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [ref, isUsed]);

  return [isClosed, setClosed];
}
